import React from 'react';
import { CalendarCheck, Map, Rocket } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';

const HowItWorks = () => {
  const { t } = useLanguage();

  const steps = [
    {
      icon: <Map className="w-8 h-8 text-accent-500" />,
      title: t('howItWorks.step1Title'),
      desc: t('howItWorks.step1Desc')
    },
    {
      icon: <CalendarCheck className="w-8 h-8 text-accent-500" />,
      title: t('howItWorks.step2Title'),
      desc: t('howItWorks.step2Desc')
    },
    {
      icon: <Rocket className="w-8 h-8 text-accent-500" />,
      title: t('howItWorks.step3Title'),
      desc: t('howItWorks.step3Desc')
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-950 mb-4">{t('howItWorks.title')}</h2>
          <p className="text-gray-600">{t('howItWorks.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connector Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gray-100 z-0"></div>

          {steps.map((step, index) => (
            <div key={index} className="relative z-10 bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all text-center group">
              <div className="w-16 h-16 mx-auto bg-primary-50 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary-950 transition-colors duration-300">
                <div className="group-hover:text-white transition-colors duration-300">
                  {step.icon}
                </div>
              </div>
              <h3 className="text-xl font-bold text-primary-950 mb-3">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
